<template>
  <div class="fund-summary">
    <div v-if="fundInfoFlag ===0 || (fundInfoFlag ===1 && isCompare)">
      <div class="title">基金投资汇总</div>
      <div class="item-container">
        <div class="item" v-for="(item, index) in summaryData" :key="index">
          <div class="term">{{ item.termname }}</div>
          <div class="data">{{ item.value }}</div>
          <div v-if="isCompare" class="data" :class="{ different: item.compareProperty != 0 }">{{ item.compareValue }}</div>
        </div>
      </div>
    </div>
    <div v-else-if="fundInfoFlag>=1 && !isCompare">
      <div class="title bold">实缴资金与投资进度</div>
      <div v-if="editStatus">
        <a-button v-if="!isEdit.fundInvestProgress" type="primary" size="small" @click="edit(1)" style="margin: 0 12px 12px 0">编辑</a-button>
        <a-button v-if="isEdit.fundInvestProgress" size="small" @click="cancel(1)" style="margin: 0 12px 12px 0">取消</a-button>
        <a-button v-if="isEdit.fundInvestProgress" type="primary" size="small" @click="save(1)" style="margin: 0 12px 12px 0">保存</a-button>
      </div>
      <a-table :columns="fundInvestProgressColumns" :data-source="[fundInvestProgress]" :pagination="false" bordered style="width: 800px">
        <span slot="paidinRatioTitle">
          <a-tooltip>
            <template slot="title">
              当前基金实缴额/基金规模
            </template>
            <span style="font-weight: bolder">到位资金比例<a-icon style="margin: 0 4px;color:rgba(0,0,0,0.65);font-size: 13px" type="question-circle"/></span>
          </a-tooltip>
        </span>
        <span slot="investProgressTitle">
          <a-tooltip>
            <template slot="title">
              累计投资成本/可投资金额
            </template>
            <span style="font-weight: bolder">投资进度<a-icon style="margin: 0 4px;color:rgba(0,0,0,0.65);font-size: 13px" type="question-circle"/></span>
          </a-tooltip>
        </span>

        <span v-for="i in fundInvestProgressColumns" :key="i.key" :slot="i.key" slot-scope="record">
          <!-- 当前基金实缴额 和 可投资金额 -->
          <span v-if="!isEdit.fundInvestProgress">{{ permil(record, 2, true) }}</span>
          <!-- // 手动填写 -->
          <span v-if="isEdit.fundInvestProgress">
            <a-input-number style="width: 80%" v-model="fundInvestProgressEdit[i.key]" :formatter="e => formatNum(e, 2)" :parser="parseNum"> </a-input-number>
          </span>
        </span>
      </a-table>
      <div style="margin-bottom: 20px;"></div>

      <div class="title bold">基金投资现状</div>
      <div v-if="editStatus">
        <a-button v-if="!isEdit.fundInvestCurrentStatus" type="primary" size="small" @click="edit(2)" style="margin: 0 12px 12px 0">编辑</a-button>
        <a-button v-if="isEdit.fundInvestCurrentStatus" size="small" @click="cancel(2)" style="margin: 0 12px 12px 0">取消</a-button>
        <a-button v-if="isEdit.fundInvestCurrentStatus" type="primary" size="small" @click="save(2)" style="margin: 0 12px 12px 0">保存</a-button>
      </div>
      <a-table :columns="fundInvestCurrentStatusColumns" :data-source="[fundInvestCurrentStatus]" :pagination="false" bordered :scroll="{ x: 1000 }">
        <span slot="allocatedAmount" slot-scope="record">
          <span v-if="isEdit.fundInvestCurrentStatus">
            <a-input-number style="width: 100%" v-model="fundInvestCurrentStatusEdit.allocatedAmount" :formatter="e => formatNum(e, 2)" :parser="parseNum">
            </a-input-number>
          </span>
          <span v-else>
            {{ permil(record, 2, true) }}
          </span>
        </span>
      </a-table>
      <div style="margin-bottom: 20px;"></div>

      <div class="title bold">基金业绩指标</div>
      <div v-if="editStatus">
        <a-button v-if="!isEdit.fundPerformanceIndicators" type="primary" size="small" @click="edit(3)" style="margin: 0 12px 12px 0">编辑</a-button>
        <a-button v-if="isEdit.fundPerformanceIndicators" size="small" @click="cancel(3)" style="margin: 0 12px 12px 0">取消</a-button>
        <a-button v-if="isEdit.fundPerformanceIndicators" type="primary" size="small" @click="save(3)" style="margin: 0 12px 12px 0">保存</a-button>
      </div>
      <a-table :columns="fundPerformanceIndicatorsColumns" :data-source="[fundPerformanceIndicators]" :pagination="false" bordered :scroll="{ x: 1000 }">
        <span v-for="i in fundPerformanceIndicatorsColumns" :key="i.key" :slot="i.key" slot-scope="record">
          <span v-if="isEdit.fundPerformanceIndicators">
            <a-input-number
              :formatter="e => formatNum(e, 4)"
              :parser="parseNum"
              style="width: 100%"
              v-model="fundPerformanceIndicatorsEdit[i.key]"
              :step="0.0001"
            ></a-input-number>
          </span>
          <span v-else>
            <!-- // 小数四位 -->
            <span v-if="i.toFixed">{{ record ? record.toFixed(i.toFixed) : '' }}</span>
            <!-- // 百分比 -->
            <span v-else-if="i.isPercentage">{{ record ? (record * 100).toFixed(2) + '%' : '' }}</span>
            <!-- // 其他 -->
            <span v-else>{{ record }}</span>
          </span>
        </span>
      </a-table>
    </div>
  </div>
</template>
<script>
import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import { fundInvestProgressColumns, fundInvestCurrentStatusColumns, fundPerformanceIndicatorsColumns, dateString, permil } from '@/utils/finance';
import { modifyFinanceFairOverview } from '@/api/finance.js';
import Event from '@/utils/event';

export default {
  name: 'FundSummary',
  props: {
    overAll: {
      type: Object,
      default: () => ({})
    },
    isCompare: {
      type: Boolean,
      default: false
    },
    versionId: {
      type: Number,
      default: undefined
    },
    fundInvestProgress: {
      type: Object,
      default: () => ({})
    },
    fundInvestCurrentStatus: {
      type: Object,
      default: () => ({})
    },
    fundPerformanceIndicators: {
      type: Object,
      default: () => ({})
    },
    editStatus: {
      type: Boolean,
      default: false
    },
    // 0-旧版 1-新版
    fundInfoFlag: {
      type: Number,
      default: 0
    }
  },
  computed: {
    summaryData() {
      const data = [];
      const summaryMap = {
        totalCompanyCount: {
          termname: '投资公司总数',
          index: 0,
          value: '',
          compareValue: '',
          compareProperty: ''
        },
        totalCost: {
          termname: '总投资成本',
          index: 1,
          value: '',
          compareValue: '',
          compareProperty: ''
        },
        unrealized: {
          termname: '累计未实现投资收益（损失）',
          index: 2,
          value: '',
          compareValue: '',
          compareProperty: ''
        },
        ingCompanyCount: {
          termname: '在投公司数量',
          index: 3,
          value: '',
          compareValue: '',
          compareProperty: ''
        },
        fairValue: {
          termname: '当前总价值',
          index: 4,
          value: '',
          compareValue: '',
          compareProperty: ''
        },

        exited: {
          termname: '已退出收益（损失）',
          index: 5,
          value: '',
          compareValue: '',
          compareProperty: ''
        }
      };
      for (let key in this.overAll) {
        let item = summaryMap[key];
        item.value = (this.overAll[key]['value'] || '-').toString().replace(/,/g, '');
        item.compareValue = (this.overAll[key]['compareValue'] || '-').toString().replace(/,/g, '');
        item.compareProperty = this.overAll[key]['compareProperty'];
        const reg = /\B(?=(\d{3})+(?!\d))/g;
        if (item.value !== '-') {
          item.value = parseFloat(item.value, 10).toFixed(2);
          item.value = item.value.toString().replace(reg, ',');
        }
        if (item.compareValue !== '-') {
          item.compareValue = parseFloat(item.compareValue, 10).toFixed(2);
          item.value = item.value.toString().replace(reg, ',');
        }
        data.push(item);
      }
      return data.sort((a, b) => {
        return a.index - b.index;
      });
    }
  },
  data() {
    return {
      typeMap: {
        1: 'fundInvestProgress',
        2: 'fundInvestCurrentStatus',
        3: 'fundPerformanceIndicators'
      },
      fundInvestProgressColumns,
      fundInvestCurrentStatusColumns,
      fundPerformanceIndicatorsColumns,
      fundInvestProgressEdit: {},
      fundInvestCurrentStatusEdit: {},
      fundPerformanceIndicatorsEdit: {},
      isEdit: {
        fundInvestProgress: false,
        fundInvestCurrentStatus: false,
        fundPerformanceIndicators: false
      }
    };
  },
  methods: {
    permil,
    getBit(value, step = 4) {
      if (value) {
        if (step === 2) {
          return `${value}`.replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3');
        } else if (step === 4) {
          return `${value}`.replace(/^(\-)*(\d+)\.(\d\d\d\d).*$/, '$1$2.$3');
        }
      } else {
        return '';
      }
    },
    edit(type) {
      let { typeMap } = this;
      this.isEdit[typeMap[type]] = true;
      this[`${typeMap[type]}Edit`] = Object.assign({}, this[typeMap[type]]);
      this.$forceUpdate();
    },
    cancel(type) {
      let { typeMap } = this;
      this.isEdit[typeMap[type]] = false;
    },
    async save(type) {
      let { typeMap } = this;
      try {
        let data = {
          modifyType: type,
          versionId: this.versionId,
          ...this[`${typeMap[type]}Edit`]
        };
        if (type === 1) {
          data.paidinAmount = this.getBit(data.paidinAmount, 2);
          data.investableAmount = this.getBit(data.investableAmount, 2);
        } else if (type === 2) {
          data.allocatedAmount = this.getBit(data.allocatedAmount, 2);
        } else if (type === 3) {
          // 小数位需要手动截取一下
          data.netMoic = this.getBit(data.netMoic, 4);
          data.grossIrr = this.getBit(data.grossIrr, 4);
          data.netIrr = this.getBit(data.netIrr, 4);
          data.tvpi = this.getBit(data.tvpi, 4);
          data.dpi = this.getBit(data.dpi, 4);
          data.netLpDpi = this.getBit(data.netLpDpi, 4);
          data.dpiWithIpo = this.getBit(data.dpiWithIpo, 4);
          data.lossRatiobyCost = this.getBit(data.lossRatiobyCost, 4);
          data.lossRatioByCompany = this.getBit(data.lossRatioByCompany, 4);
        }
        let res = await modifyFinanceFairOverview(data);
        if (res.code === 200) {
          this.$message.success('保存成功');
        }
      } catch (e) {
        console.log(e);
      }
      this.isEdit[typeMap[type]] = false;
      Event.$emit('visionRefresh');
    },
    formatNum(value, step) {
      if (step === 1) {
        return `${value}`.replace(/^(\-)*(\d+)\.(\d).*$/, '$1$2.$3'); // 保留小数位
      } else if (step === 2) {
        return `${value}`.replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3');
      } else if (step === 4) {
        return `${value}`.replace(/^(\-)*(\d+)\.(\d\d\d\d).*$/, '$1$2.$3');
      } else {
        return `${value}`.replace(/(?<!\..*)\B(?=(\d{3})+(?!\d))/g, ',');
      }
    },
    parseNum(value) {
      return value.replace(/\$\s?|(,*)/g, '');
    }
  }
};
</script>
<style scoped lang="less">
.fund-summary {
  .title {
    font-weight: bold;
    font-size: 16px;
    margin: 0 0 12px 0;
  }
  .item-container {
    margin-bottom: 30px;
    display: grid;
    grid-template-columns: auto auto auto;
    .item {
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
      .term {
        font-size: 16px;
        font-weight: bold;
      }
      .data {
        margin: 10px 0 20px 0;
        font-size: 16px;
        font-weight: bold;
        color: #3f51b5;
      }
      .different {
        color: red !important;
      }
    }
  }
}

.calculate {
  font-style: italic;
  color: #5f9f9f;
}

/deep/.ant-table-thead > tr > th {
  padding: 8px 8px;
  font-size: 13px;
}

/deep/.ant-table-tbody > tr > td {
  padding: 8px;
  font-size: 13px;
  &.calculate {
    color: #5f9f9f;
    font-style: italic;
  }
}

/deep/.ant-table-column-title {
  font-weight: bolder;
}

/deep/ .ant-table-tbody > tr:hover:not(.ant-table-expanded-row) > td {
  background-color: white;
}
</style>
